import { Swiper } from "swiper"

function logoSwiper() {
    const swiper = new Swiper(".logo-swiper", {
        slidesPerView: 1,
        autoplay: {
            delay: 3000,
        },
        breakpoints: {
            1024: {
                slidesPerView: 5,
            },
            768: {
                slidesPerView: 3,
            },
            576: {
                slidesPerView: 2,
            },
        },
    })

    const arrowPrev = document.querySelector(".logo-swiper-wrapper .arrow-prev")
    const arrowNext = document.querySelector(".logo-swiper-wrapper .arrow-next")

    arrowPrev.addEventListener("click", () => {
        swiper.slidePrev()
    })

    arrowNext.addEventListener("click", () => {
        swiper.slideNext()
    })
}

if (document.querySelector(".logo-swiper-wrapper")) {
    logoSwiper()
}
